<template>
    <div :class="classes">
        <u-upload
            :accept="accept"
            listType="none"
            :files="files"
            @change="handleChange"
			:size="size"
			:imgWidth="imgWidth"
			:imgHeight="imgHeight"
            :disabled="disabled"
            :drag="drag"
            @progress="onProgress"
        >
            <el-button :disabled="disabled" size="small" :type="value ? '' : 'primary'">{{ value ? '重新上传' : btnText }}</el-button>
        </u-upload>
        <p
            :class="`${prefix}-tips`"
        >{{ tipsText ? tipsText : `${limitPx ? '限制' : '建议'}${imgWidth}*${imgHeight}px，格式${accept}，大小不超过${size}M` }}</p>

        <div :class="[`${prefix}-review`, { [`${prefix}-loading`]: percent < 100 }]">
            <div class="showLoading">{{value}}</div>
            <div :class="`${prefix}-loader-mask`" v-if="percent < 100">
                <el-progress type="circle" :percentage="Math.round(percent)"></el-progress>
            </div>
        </div>
    </div>
</template>
<script>
const prefix = "w-upload-file";

export default {
    props: {
        value: String,
        tipsText: String,
        btnText: {
            type: String,
            default: '上传文件'
        },
        accept: {
            type: String,
            default: ".zip",
        },
        imgHeight: {
            type: Number,
            default: 600,
        },
        imgWidth: {
            type: Number,
            default: 1960,
        },
        size: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        // 限制像素大小
        limitPx: {
            type: Boolean
        },
        drag:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            prefix,
            percent: 100
        };
    },
    created() {},
    computed: {
        classes() {
            return [prefix];
        },
        files() {
            return this.value ? [{ url: this.value }] : []
        }
    },
    methods: {
        handleChange(list) {
			if(list.length) {
				let img = list.splice(-1);
                let fileName = img[0].name.lastIndexOf(".") // 取到文件名开始到最后一个点的长度
                let fileType = img[0].name.substring(fileName + 1, fileName.length)
                if (fileType != 'zip') {
                    this.$message.warning('请上传zip格式')
                    return
                }
                this.$emit("input",  img[0].name, img[0].url);
			}
        },
        onProgress(event) {
            this.percent = event.percent
        }
    }
};
</script>

<style lang="scss">
$prefixCls: w-upload-file;

.#{$prefixCls} {
    &-review {
        margin-top: 10px;
        border-radius: 4px;
        position: relative;
        img{
            max-width: 400px;
            max-height: 300px;
        }
    }
    &-loading{
        width: 200px;
        height: 200px;
    }
    &-tips {
        color: #bbb;
    }
    &-loader-mask{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba($color: #000, $alpha: 0.6);
        display: flex;
        justify-content: center;
        align-items: center;
        .el-progress__text{
            color: white;
        }
    }
}
.showLoading img,video{
    max-width: 320px;
    max-height: 640px;
}
</style>
